import React, { useEffect, useRef } from "react";
import kfmb from '../assets/images/kfmb.svg';
import flour from '../assets/images/imgs/BRANDS & PARTNERS 4 copy.png'
import pasta from '../assets/images/imgs/pasta.png'
import ghee from '../assets/images/imgs/ghee.png'
import biscuits from '../assets/images/imgs/biscuits.png'
import rugag from '../assets/images/imgs/rugag.png'
import rusk from '../assets/images/imgs/rusk.png'
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function KFMB() {
    const { t } = useTranslation();
    const navigate = useNavigate()

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('brands');
    }, [])

    const kfmpSection = useRef()
    const pinnedRef = useRef()

    window.onscroll = () => {
        if (kfmpSection.current.getBoundingClientRect().top < 20 && kfmpSection.current.getBoundingClientRect().top > -(kfmpSection.current.getBoundingClientRect().height - 280)) {
            pinnedRef.current.classList.add('fixed')
        } else {
            pinnedRef.current.classList.remove('fixed')
        }
    }
    return (
        <section className="relative flex gap-[20px] p-[20px] lg:p-[100px]" ref={kfmpSection}>
            <div className="w-[80px] min-w-[80px] lg:w-[150px] lg:min-w-[150px] relative">
                <div onClick={()=>navigate(-1)} ref={pinnedRef} className="z-[999] top-[120px] bg-white border-[#D0A847] border-[2px] w-[80px] min-w-[80px] h-[80px] lg:w-[150px] lg:min-w-[150px] lg:h-[150px] flex items-center justify-center rounded-[10px] transition-all duration-700 cursor-pointer">
                    <img src={kfmb} className="w-[50px] min-w-[50px] lg:w-[100px] lg:min-w-[100px]" alt="" />
                </div>
            </div>
            <div className="flex flex-col gap-[20px] px-[0px] lg:px-[100px] nc">
                <h1 className="text-[#D0A847] text-xl lg:text-3xl 2xl:text-6xl nc">{t('partner1_name')}</h1>
                <h2 className="capitalize text-md lg:text-xl nc">{t('kfmb_desc')}</h2>
                <div className="flex flex-col gap-[50px] nc">
                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('flour_family')}</h3>
                    <img src={flour} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('pasta_family')}</h3>
                    <img src={pasta} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('vegetable_ghee')}</h3>
                    <img src={ghee} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('biscuits_family')}</h3>
                    <img src={biscuits} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('rugag_bread')}</h3>
                    <img src={rugag} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('rusk')}</h3>
                    <img src={rusk} className="w-full lg:w-3/4 m-auto" alt="" />
                </div>
            </div>
        </section>
    )
}